import type { Dict } from "../../../../shared/i18n";

/** Переводы: русский исходник → [литовский, английский]
 *  Оболочка: вход, список поездок, приглашения, печать, экран поездки, таймлайн, карта, общие кнопки */
export default {
  // вход (components/screens.tsx)
  "Карта, план по дням, идеи друзей и ИИ-ассистент — для путешествий вместе.": [
    "Žemėlapis, dienų planas, draugų idėjos ir DI asistentas – keliaujantiems kartu.",
    "Map, day-by-day plan, friends' ideas and an AI assistant — for travelling together.",
  ],
  "Вас пригласили в поездку «{title}»": ["Esate pakviesti į kelionę „{title}“", "You're invited to the trip “{title}”"],
  "Войти через Google": ["Prisijungti su Google", "Sign in with Google"],
  "Тестовый вход (только разработка)": ["Bandomasis prisijungimas (tik kūrimui)", "Test sign-in (development only)"],
  "Войти": ["Prisijungti", "Sign in"],

  // новая поездка
  "Вильнюс": ["Vilnius", "Vilnius"],
  "Название и даты": ["Įveskite pavadinimą ir datas", "Enter a name and dates"],
  "Новая поездка": ["Nauja kelionė", "New trip"],
  "Отмена": ["Atšaukti", "Cancel"],
  "Создать": ["Sukurti", "Create"],
  "Название": ["Pavadinimas", "Name"],
  "Япония весной": ["Japonija pavasarį", "Japan in spring"],
  "С": ["Nuo", "From"],
  "По": ["Iki", "To"],
  "Откуда летим": ["Iš kur skrendame", "Flying from"],

  // список поездок
  "Привет, {name}": ["Sveiki, {name}", "Hi, {name}"],
  "Выйти": ["Atsijungti", "Sign out"],
  "{n} дн.|{n} дн.|{n} дн.": ["{n} diena|{n} dienos|{n} dienų", "{n} day|{n} days"],
  "приглашение": ["pagal kvietimą", "invited"],
  "Вьетнам · 6–28 апреля 2027 · из Вильнюса": ["Vietnamas · 2027 m. balandžio 6–28 d. · iš Vilniaus", "Vietnam · 6–28 April 2027 · from Vilnius"],
  "Черновик маршрута север → юг: 54 места, план на 23 дня, переезды и чек-лист. Можно сразу менять или попросить ИИ перестроить.": [
    "Maršruto juodraštis iš šiaurės į pietus: 54 vietos, 23 dienų planas, persikėlimai ir užduočių sąrašas. Galite iškart keisti arba paprašyti DI jį perdaryti.",
    "Draft route from north to south: 54 places, a 23-day plan, transfers and a checklist. Edit it right away or ask the AI to rework it.",
  ],
  "Создать из шаблона": ["Sukurti iš šablono", "Create from template"],

  // приглашение
  "Приглашение недействительно или истекло": ["Kvietimas neteisingas arba pasibaigė jo galiojimas", "This invite is invalid or has expired"],
  "Попросите друга прислать новую ссылку.": ["Paprašykite draugo atsiųsti naują nuorodą.", "Ask your friend to send a new link."],

  // печатная версия
  "День {n} · {weekday}, {date}": ["{n} diena · {weekday}, {date}", "Day {n} · {weekday}, {date}"],
  "День {n} · {weekday}, {date} — ночь: {stay}": ["{n} diena · {weekday}, {date} – nakvynė: {stay}", "Day {n} · {weekday}, {date} — night: {stay}"],
  "бронь {ref}": ["rezervacija {ref}", "booking {ref}"],

  // экран поездки (components/TripView.tsx)
  "План": ["Planas", "Plan"],
  "Места": ["Vietos", "Places"],
  "Материалы": ["Šaltiniai", "Sources"],
  "Медиа": ["Šaltiniai", "Sources"],
  "Задачи": ["Užduotys", "Tasks"],
  "Бюджет": ["Biudžetas", "Budget"],
  "Поездка": ["Kelionė", "Trip"],
  "Ещё": ["Daugiau", "More"],
  "Поездка не открылась": ["Nepavyko atidaryti kelionės", "Couldn't open the trip"],
  "Нет доступа или нет сети": ["Nėra prieigos arba interneto ryšio", "No access or no connection"],
  "К списку поездок": ["Į kelionių sąrašą", "Back to trips"],
  "Место добавлено на карту": ["Vieta pridėta į žemėlapį", "Place added to the map"],
  "Офлайн — показана сохранённая копия": ["Be ryšio – rodoma išsaugota kopija", "Offline — showing a saved copy"],
  "Все поездки": ["Visos kelionės", "All trips"],
  "Скрыть панель": ["Slėpti skydelį", "Hide panel"],
  "Показать панель": ["Rodyti skydelį", "Show panel"],
  "ИИ-ассистент": ["DI asistentas", "AI assistant"],

  // таймлайн (components/Timeline.tsx, lib/trip.ts)
  "Пауза": ["Pristabdyti", "Pause"],
  "Проиграть поездку по дням": ["Peržiūrėti kelionę dieną po dienos", "Play the trip day by day"],
  "Предыдущий день": ["Ankstesnė diena", "Previous day"],
  "Следующий день": ["Kita diena", "Next day"],
  "Дни поездки": ["Kelionės dienos", "Trip days"],
  "Все": ["Visos", "All"],
  "Сегодня": ["Šiandien", "Today"],
  "в пути": ["kelyje", "in transit"],

  // общие (components/ui.tsx)
  "Закрыть": ["Uždaryti", "Close"],

  // поиск на карте (components/map/MapSearch.tsx)
  "Найти место или вставить ссылку…": ["Ieškokite vietos arba įklijuokite nuorodą…", "Find a place or paste a link…"],
  "Очистить": ["Išvalyti", "Clear"],
  "В поездке": ["Šioje kelionėje", "In this trip"],
  "Найдено на карте — нажмите, чтобы добавить": ["Rasta žemėlapyje – paspauskite, kad pridėtumėte", "Found on the map — tap to add"],
  "Разобрать ссылку с ИИ": ["Išanalizuoti nuorodą su DI", "Analyse link with AI"],
  "Добавить с помощью ИИ": ["Pridėti su DI", "Add with AI"],

  // карта (components/map/TripMap.tsx)
  "{name} — нажмите, чтобы добавить": ["{name} – paspauskite, kad pridėtumėte", "{name} — tap to add"],
  "Не удалось определить местоположение": ["Nepavyko nustatyti jūsų buvimo vietos", "Couldn't get your location"],
  "Слои карты": ["Žemėlapio sluoksniai", "Map layers"],
  "Карта": ["Žemėlapis", "Map"],
  "Минимальная": ["Minimalus", "Minimal"],
  "Рельеф": ["Reljefas", "Terrain"],
  "Спутник": ["Palydovas", "Satellite"],
  "Тёмная карта": ["Tamsus žemėlapis", "Dark map"],
  "Тёмная минимальная": ["Tamsus minimalus", "Dark minimal"],
  "Скрыть маршрут": ["Slėpti maršrutą", "Hide route"],
  "Показать маршрут": ["Rodyti maršrutą", "Show route"],
  "Скрыть голоса и комментарии": ["Slėpti balsus ir komentarus", "Hide votes and comments"],
  "Показать голоса и комментарии": ["Rodyti balsus ir komentarus", "Show votes and comments"],
  "Только места из плана": ["Tik plano vietos", "Only places in the plan"],
  "Показать все идеи": ["Rodyti visas idėjas", "Show all ideas"],
  "Показать всю поездку": ["Rodyti visą kelionę", "Show the whole trip"],
  "Где я": ["Kur aš esu", "My location"],
  "Отменить добавление": ["Atšaukti pridėjimą", "Cancel adding"],
  "Добавить точку на карте": ["Pridėti tašką žemėlapyje", "Add a point on the map"],
  "Нажмите на карту, чтобы поставить место": ["Paspauskite žemėlapį, kad pažymėtumėte vietą", "Tap the map to add a place"],
} satisfies Dict;
